import {
  type SanityProductGalleryPhoto,
  type SanityProductVariantFragment,
} from '@data/sanity/queries/types/product'

import ProductGallery from './product-gallery'

interface ProductHeroGalleryProps {
  photosets: SanityProductGalleryPhoto[]
  variant: SanityProductVariantFragment
  previewVariant?: SanityProductVariantFragment
}

const ProductHeroGallery = ({
  photosets,
  variant,
  previewVariant,
}: ProductHeroGalleryProps) => {
  return (
    <div className="relative bg-pageBG">
      <ProductGallery
        photosets={photosets}
        activeVariant={variant}
        previewVariant={previewVariant}
        hasArrows
        hasCounter
        hasDrag
        preloadFirstPhoto
      />
    </div>
  )
}

export default ProductHeroGallery
